
import { useQuery } from "react-query";
import { EcoGetQuery, MapResponseFn } from "@eco/client";
import useEcoClient from "hooks/useEcoClient";


/**
 * 
 * Custom hook to perform a get query to backend 
 */
const useGetQuery = <T, R = unknown> (
    queryName: string, 
    query: EcoGetQuery,
    mapResponseFn?: MapResponseFn<T,R>
) => 
{
    const ecoClient = useEcoClient() ;
    
    const queryFn = async () => ecoClient!.get<T,R>(query, mapResponseFn);

    return useQuery(queryName, queryFn, query.config?.reactQuery);

}

export default useGetQuery ;
